import { getRootAppWindow } from "meta/utils/getRootAppWindow";
import { openVerticalTab, refreshChartTab } from "screens/Root/actions/chartTabActions";
import { useDispatch } from "react-redux";
import { useRootSelector } from "../useAppSelector";
export const useChartTabsAPI = () => {
    const { activeTabKey } = useRootSelector();
    const dispatch = useDispatch();
    const rootFrame = getRootAppWindow(window);
    const addNewVerticalTab = (tabTitle, url, pageUniqueId, parentTabUniqueId, parentTabTitle, insertAfterTabWithUniqueId) => {
        if (rootFrame?.frames[activeTabKey])
            rootFrame.frames[activeTabKey].RootCommunicator.addChartTab({
                title: tabTitle,
                url,
                uniqueId: pageUniqueId,
                parentUniqueId: parentTabUniqueId,
                parentTitle: parentTabTitle,
                insertAfter: insertAfterTabWithUniqueId,
            });
    };
    //Opens the specified vertical tab by UniqueID
    const handleOpenVerticalTab = (uniqueId, url, forceUpdate = false) => dispatch(openVerticalTab(uniqueId, url, forceUpdate));
    const handleRefreshChartTab = (callBack, ignoreUnsavedCheck) => {
        dispatch(refreshChartTab(ignoreUnsavedCheck));
        callBack?.();
    };
    const initPatientChart = (frameName, payload) => {
        const topFrame = getRootAppWindow(window);
        if (topFrame?.frames[frameName]) {
            topFrame.frames[frameName].RootCommunicator.initPatientChart(payload.children, payload.visId, payload.InitialUrl, payload.InitialTitle, payload.InitialTab);
        }
    };
    const recoverPatientChart = (frameName, initialUrl) => {
        const topFrame = getRootAppWindow(window);
        if (topFrame?.frames[frameName]) {
            topFrame.frames[frameName].RootCommunicator.recoverPatientChart(initialUrl);
        }
    };
    return {
        addNewVerticalTab,
        openVerticalTab: handleOpenVerticalTab,
        refreshChartTab: handleRefreshChartTab,
        initPatientChart,
        recoverPatientChart
    };
};
